import { Flex } from '@mantine/core';

export default function TabContent({
  leftSection,
  rightSection,
  children,
}: {
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <>
      <Flex mt={'md'} justify={'space-between'}>
        <Flex>{leftSection}</Flex>
        <Flex>{rightSection}</Flex>
      </Flex>
      <div
        style={{
          border: '1px solid var(--mantine-color-gray-1)',
          borderRadius: '5px',
          marginTop: '1em',
          position: 'relative',
        }}
      >
        {children}
      </div>
    </>
  );
}
